import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ContentBlock from '../_components/ContentBlock'

const useStyles = makeStyles<Theme, UploadPhotosProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'UploadPhotos' }
)

export interface UploadPhotosProps {
  classes?: StyleClasses<typeof useStyles>
}

function UploadPhotos(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentBlock
        img={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/upload-your-photos.png'}
        preTitle="EXPERIENCE YOUR COLORS"
        title={
          <>
            Upload Your
            <br />
            Photos
          </>
        }
        description={
          <>
            See our colors in your space -- upload
            <br />
            a photo of your own space and add
            <br />
            any color!
          </>
        }
        linkHref="https://www.sherwin-williams.com/visualizer#/active/scenes"
        linkLabel="Upload Your Photo"
        styles={{ padding: '80px 40px 40px' }}
      />
    </div>
  )
}

export default UploadPhotos
